export default "__VITE_ASSET__CI9p_1KU__"